import React from 'react';
import { Box, Paper } from '@mui/material';

export const MyPanel = ({ children, sx = {}, ...props }) => (
  <Paper
    variant="outlined"
    sx={{
      backgroundColor: 'var(--panel)',
      color: 'var(--fg)',
      borderColor: 'var(--border)',
      borderRadius: 'var(--radius-8)',
      boxShadow: 'var(--shadow-soft)',
      overflow: 'hidden',
      ...sx,
    }}
    {...props}
  >
    {children}
  </Paper>
);

export const MyPanelHeader = ({ children, sx = {}, ...props }) => (
  <Box
    sx={{
      backgroundColor: 'var(--panel-2)',
      color: 'var(--fg)',
      borderBottom: '1px solid var(--line)',
      minHeight: 'var(--ui-header-height)',
      px: 'var(--ui-header-px)',
      py: 0,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Box>
);

export const MyPanelBody = ({ children, sx = {}, ...props }) => (
  <Box sx={{ px: 2, py: 2, color: 'var(--fg)', ...sx }} {...props}>
    {children}
  </Box>
);

export const MyPanelFooter = ({ children, sx = {}, ...props }) => (
  <Box
    sx={{
      backgroundColor: 'var(--panel-2)',
      color: 'var(--fg)',
      borderTop: '1px solid var(--line)',
      px: 2,
      py: 1,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Box>
);

export default MyPanel;
